import { useMemo } from "react";
import {
  simulateProgram,
  type Exercise,
  type Program,
  type ProgramSimulation,
} from "@heraion/shared";

// #492 F5: one simulation per (program, catalog) object pair, for the preview and ProgramPlanGaps.
const byProgram = new WeakMap<Program, WeakMap<ReadonlyArray<Exercise>, ProgramSimulation>>();

const simulationOf = (program: Program, catalog: ReadonlyArray<Exercise>): ProgramSimulation => {
  const byCatalog = byProgram.get(program) ?? new WeakMap();
  byProgram.set(program, byCatalog);
  const hit = byCatalog.get(catalog);
  if (hit) return hit;
  const sim = simulateProgram(program, catalog);
  byCatalog.set(catalog, sim);
  return sim;
};

/** The program as written, on an athlete with no history. Null: no catalog. */
export function useProgramSimulation(
  program: Program,
  catalog: ReadonlyArray<Exercise> | null,
): ProgramSimulation | null {
  return useMemo(() => (catalog ? simulationOf(program, catalog) : null), [program, catalog]);
}
